export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const toFixed = (num: any, precision = 1) => {
  return (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
    precision
  );
};

// Format a numeric reading for the report tables/Excel: a dash when the value
// is missing (null/undefined) or already "-", otherwise toFixed. Replaces the
// repeated `(v ?? "-") !== "-" ? toFixed(v ?? 0, 1) : "-"` idiom.
export const toFixedOrDash = (value: any, precision = 1) => {
  return (value ?? "-") !== "-" ? toFixed(value ?? 0, precision) : "-";
};

export const MathRound = (value: any, precision = 1) => {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
};
